/**
 * @readonly
 * @enum {string}
 */
export const Mode = {
  Dialog: 'dialog',
  MenuBar: 'menubar',
};